import React, { useEffect, useState } from "react";
import { api, money } from "@/lib/api";
import { imgUrl } from "@/lib/api";
import { TrendingUp } from "lucide-react";
import SupporterWall from "@/components/SupporterWall";

export default function TransparencyPage() {
  const [items, setItems] = useState([]);
  const [donate, setDonate] = useState("");
  useEffect(() => {
    api.get("/transparency").then(({ data }) => setItems(data)).catch(() => {});
    api.get("/settings").then(({ data }) => setDonate(data.gofundme_url || "")).catch(() => {});
  }, []);

  const total = items.reduce((a, i) => a + (Number(i.amount) || 0), 0);

  return (
    <div data-testid="transparency-page">
      <section className="max-w-4xl mx-auto px-6 lg:px-10 pt-20 pb-8">
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#C1272D] mb-3">Transparency Center</p>
        <h1 className="font-display text-5xl sm:text-6xl font-bold tracking-tight text-[#1F4D2E] leading-[0.95]">Every dollar, accounted for.</h1>
        <p className="text-lg text-[#4F6B54] mt-6 leading-relaxed">We believe trust is earned. Here's an honest timeline of how donations have turned into real impact for the children in our care.</p>
        <div className="mt-8 inline-flex items-center gap-3 bg-[#E7EDE2] px-6 py-4 rounded-lg">
          <TrendingUp className="text-[#16A34A]" />
          <span className="text-[#1F4D2E]"><b className="text-xl">{money(total)}</b> put to work in recent updates</span>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 lg:px-10 pb-24">
        {items.length === 0 ? (
          <p className="text-[#4F6B54] py-16 text-center" data-testid="no-updates">No updates published yet.</p>
        ) : (
          <div className="relative border-l-2 border-[#1F4D2E]/15 ml-3 mt-6" data-testid="transparency-timeline">
            {items.map((u) => (
              <div key={u.id} className="relative pl-10 pb-12" data-testid={`transparency-item-${u.id}`}>
                <span className="absolute -left-[9px] top-1.5 w-4 h-4 rounded-full bg-[#C1272D] border-4 border-[#FBF8F0]" />
                <span className="text-xs text-[#4F6B54] uppercase tracking-wider">{new Date(u.date).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</span>
                <div className="flex flex-wrap items-center gap-3 mt-1 mb-2">
                  <h3 className="font-display text-2xl font-semibold text-[#1F4D2E]">{u.title}</h3>
                  {u.amount != null && u.amount !== "" && <span className="bg-[#16A34A]/10 text-[#16A34A] text-sm font-bold px-3 py-1 rounded-full">{money(u.amount)}</span>}
                </div>
                {u.image_url && <img src={imgUrl(u.image_url)} alt={u.title} className="w-full max-w-md h-56 object-cover rounded-lg mb-3" />}
                <p className="text-[#4F6B54] leading-relaxed max-w-2xl">{u.body}</p>
              </div>
            ))}
          </div>
        )}
      </section>

      <div className="bg-[#FBF8F0] border-t border-[#1F4D2E]/10">
        <SupporterWall donateUrl={donate} />
      </div>
    </div>
  );
}
